module.exports = __webpack_public_path__ + "img/bounding-box-circles.0e34a14b.svg";